import { RawDraftContentState } from 'draft-js';

export const EMPTY_RAW_DRAFT_CONTENT_STATE: RawDraftContentState = {
  blocks: [],
  entityMap: {},
};
